export const IMAGE_SMALL = 300
export const IMAGE_LARGE = 600

const cache: Record<string, boolean> = {}

export const imageCache = {
  addUrl(url: string) {
    cache[url] = true
  },
  isImageUrlInCache(url: string) {
    return !!cache[url]
  },
  isImageSizeCached(imageUrl: string, size: number) {
    return Object.keys(cache).find((url) => {
      const cachedUrl = new URL(url)
      const cachedUrlWithPath = `${cachedUrl.origin}${cachedUrl.pathname}`

      const lookupUrl = new URL(imageUrl)
      const lookupUrlWithPath = `${lookupUrl.origin}${lookupUrl.pathname}`

      return (
        cachedUrlWithPath === lookupUrlWithPath &&
        url.toLowerCase().includes(`width=${size}`)
      )
    })
  },
}
